export default "__VITE_ASSET__XEq1VY1X__"